import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "primereact/dropdown";
import Swal from "sweetalert2";
import { termsOfUseHtml } from "../../legal/termsOfUse";
import { privacyPolicyHtml } from "../../legal/privacyPolicy";

const Footer = () => {
  const { t, i18n } = useTranslation();

  const languageOptions = [
    { label: "简体中文", value: "zh_CN" },
    { label: "English", value: "en_CA" },
    { label: "Français", value: "fr_CA" },
  ];

  useEffect(() => {
    const savedLang = localStorage.getItem("miracleLanguage");
    if (savedLang) {
      i18n.changeLanguage(savedLang);
    } else {
      i18n.changeLanguage("en_CA");
      localStorage.setItem("miracleLanguage", "en_CA");
    }
  }, [i18n]);

  const onChangeArea = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem("miracleLanguage", langCode);
  };

  const showLegalModal = () => {
    Swal.fire({
      title: "Terms of Use & Privacy Policy",
      html: `
        <div style="text-align:left;font-family:Arial, sans-serif;line-height:1.6;color:#333;">
          <p>
            Before using this service, please review our
            <strong> Terms of Use </strong> and <strong> Privacy Policy</strong>.
          </p>

          <div style="margin-bottom:12px; display:flex; gap:10px;">
            <!-- Terms button -->
            <button
              type="button"
              id="show-terms-btn"
              style="
                padding: 8px 14px;
                border-radius: 6px;
                font-weight: 600;
                cursor: pointer;
                border: none;
              "
            >
              View Terms of Use
            </button>

            <!-- Privacy button -->
            <button
              type="button"
              id="show-privacy-btn"
              style="
                padding: 8px 14px;
                border-radius: 6px;
                font-weight: 600;
                cursor: pointer;
                border: 2px solid transparent;
              "
            >
              View Privacy Policy
            </button>
          </div>

          <div
            id="legal-content"
            style="border:1px solid #ddd;padding:10px;max-height:40vh;overflow:auto;margin-bottom:12px;"
          ></div>
        </div>
      `,
      focusConfirm: false,
      showCancelButton: false,
      confirmButtonText: "Close",
      customClass: {
        popup: "text-left",
      },
      didOpen: () => {
        const contentDiv = document.getElementById("legal-content");
        const termsBtn = document.getElementById("show-terms-btn");
        const privacyBtn = document.getElementById("show-privacy-btn");
        const primaryColor = "#0d6efd";

        const setActive = (active) => {
          if (!termsBtn || !privacyBtn) return;

          if (active === "terms") {
            termsBtn.style.backgroundColor = primaryColor;
            termsBtn.style.color = "white";
            termsBtn.style.border = "none";

            privacyBtn.style.backgroundColor = "white";
            privacyBtn.style.color = primaryColor;
            privacyBtn.style.border = `2px solid ${primaryColor}`;
          } else {
            privacyBtn.style.backgroundColor = primaryColor;
            privacyBtn.style.color = "white";
            privacyBtn.style.border = "none";

            termsBtn.style.backgroundColor = "white";
            termsBtn.style.color = primaryColor;
            termsBtn.style.border = `2px solid ${primaryColor}`;
          }
        };

        if (contentDiv) {
          contentDiv.innerHTML = termsOfUseHtml;
          setActive("terms");
        }

        if (termsBtn && contentDiv) {
          termsBtn.addEventListener("click", () => {
            contentDiv.innerHTML = termsOfUseHtml;
            setActive("terms");
          });
        }

        if (privacyBtn && contentDiv) {
          privacyBtn.addEventListener("click", () => {
            contentDiv.innerHTML = privacyPolicyHtml;
            setActive("privacy");
          });
        }
      },
    });
  };

  return (
    <div className="footer">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-10 col-md-10">
            <div className="copy_right">
              © 2025 MIRACLE PACE INC.. All Rights Reserved.
            </div>

            <div className="copy_right">
              <button
                type="button"
                onClick={showLegalModal}
                style={{
                  background: "none",
                  border: "none",
                  color: "white",
                  padding: 0,
                  textDecoration: "underline",
                  cursor: "pointer",
                  font: "inherit",
                }}
              >
                Terms of Use & Privacy Policy
              </button>
            </div>
          </div>

          <div className="col-xl-1 col-md-1">
            <Dropdown
              value={i18n.language}
              options={languageOptions}
              onChange={(e) => onChangeArea(e.value)}
              style={{ width: "175px", color: "white" }}
              placeholder={t("select.label")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
